'use client'

// Addons can only be in the basket if the user already passed Extras and navigated back here.
export const ExtrasResetNotice = () => {
  // const { basket } = useBasket()
  // const { t } = useTranslation()

  // for now disabled until we have resource in place
  return null
  // if (!basket?.departures.some((departure) => departure.addons.length > 0)) return null

  // return (
  //   // On lg the gap above comes from LayoutHeader's py-xl and the content below has no padding, so match it here.
  //   <div className="px-semantic-global-md md:px-semantic-global-lg pt-semantic-global-md lg:pb-semantic-global-xl lg:px-0 lg:pt-0">
  //     <InlineNotification data-e2e="departures-extras-reset-notice" variant="warning">
  //       <MarkDown>{t('DEPARTURES-EXTRAS-RESET-WARNING')}</MarkDown>
  //     </InlineNotification>
  //   </div>
  // )
}
